const slotEventListeners = new Map();

export function registerSlotEventListeners({
  slotId,
  onSlotRenderEnded,
  onSlotVisibilityChanged,
  onImpressionViewable,
}) {
  if (!slotId) {
    return;
  }
  slotEventListeners.set(slotId, {
    onSlotRenderEnded,
    onSlotVisibilityChanged,
    onImpressionViewable,
  });
}

export function unregisterSlotEventListeners(slotId) {
  if (!slotId) {
    return;
  }
  slotEventListeners.delete(slotId);
}

function dispatchSlotEvent(event, listenerName) {
  const slotId = event?.slot?.getSlotElementId?.();
  if (!slotId) {
    return;
  }

  const listener = slotEventListeners.get(slotId)?.[listenerName];
  if (typeof listener === 'function') {
    listener(event);
  }
}

export function dispatchSlotRenderEndedEvent(event) {
  dispatchSlotEvent(event, 'onSlotRenderEnded');
}

export function dispatchSlotVisibilityChangedEvent(event) {
  dispatchSlotEvent(event, 'onSlotVisibilityChanged');
}

export function dispatchImpressionViewableEvent(event) {
  dispatchSlotEvent(event, 'onImpressionViewable');
}

export function resetGptSlotEventRegistryForTest() {
  slotEventListeners.clear();
}
